import React from 'react';

import { uploadUrl } from './uploadUrl';
import {
  IconAnchor,
  IconContainer,
  IconLabel,
  NotificationDot,
} from './buttonStyles';
import trackClick from 'js/utils/trackClick';

type Props = {
  hasUnseenClaimablePapers: boolean;
  hasUnseenUploadableStubs: boolean;
  showNotificationBadges: boolean;
};

const UploadButton = ({
  hasUnseenClaimablePapers,
  hasUnseenUploadableStubs,
  showNotificationBadges = true,
}: Props) => {
  const url = uploadUrl({
    hasUnseenUploadableStubs,
    hasUnseenClaimablePapers,
    trigger: 'nav',
  });

  const handleOnClick = () => {
    trackClick({
      source: 'nav-bar--upload-button',
    });
  };

  return (
    <IconAnchor href={url} onClick={handleOnClick}>
      <IconContainer>
        <svg
          width="17"
          height="17"
          viewBox="0 0 17 17"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M9.05872 4.1805L8.89188 15.6793L7.89198 15.6648L8.05882 4.16599L8.07633 2.95901L7.21049 3.80009L1.98992 8.87133L1.28744 8.14817L8.60422 1.04068L15.7117 8.35746L14.9886 9.05993L9.91731 3.83937L9.07623 2.97352L9.05872 4.1805Z"
            fill="#6B6B82"
            stroke="#6B6B82"
          />
        </svg>
      </IconContainer>
      <IconLabel>
        Upload
        {showNotificationBadges &&
          (hasUnseenClaimablePapers || hasUnseenUploadableStubs) && (
            <NotificationDot />
          )}
      </IconLabel>
    </IconAnchor>
  );
};

export default UploadButton;
